// Employment Type options
export const employmentTypes = [
  'Full-time',
  'Part-time',
  'Contract',
  'Temporary',
  'Internship',
  'Freelance',
  'Self-employed',
  'Other',
];

// Designation options
export const designations = [
  // Software & IT
  'Software Engineer',
  'Senior Software Engineer',
  'Software Developer',
  'Full Stack Developer',
  'Frontend Developer',
  'Backend Developer',
  'Mobile App Developer',
  'DevOps Engineer',
  'System Administrator',
  'Network Engineer',
  'Database Administrator',
  'Data Scientist',
  'Data Analyst',
  'Business Analyst',
  'QA Engineer',
  'Test Engineer',
  'UI/UX Designer',
  'Product Manager',
  'Project Manager',
  'Scrum Master',
  'Technical Lead',
  'Team Lead',
  'IT Manager',
  'CTO',
  'VP Engineering',

  // Management & Business
  'CEO',
  'Managing Director',
  'General Manager',
  'Operations Manager',
  'Business Development Manager',
  'Sales Manager',
  'Marketing Manager',
  'HR Manager',
  'Finance Manager',
  'Account Manager',
  'Administrative Manager',
  'Branch Manager',
  'Regional Manager',
  'Director',
  'Vice President',
  'Executive',
  'Senior Executive',
  'Assistant Manager',
  'Deputy Manager',

  // Finance & Accounting
  'Accountant',
  'Senior Accountant',
  'Financial Analyst',
  'Auditor',
  'Tax Consultant',
  'Finance Executive',
  'Accounts Executive',
  'CFO',
  'Finance Controller',
  'Treasury Manager',
  'Investment Analyst',

  // Sales & Marketing
  'Sales Executive',
  'Sales Representative',
  'Marketing Executive',
  'Digital Marketing Manager',
  'Content Writer',
  'SEO Specialist',
  'Social Media Manager',
  'Brand Manager',
  'Marketing Coordinator',
  'Business Development Executive',

  // HR & Administration
  'HR Executive',
  'Recruitment Specialist',
  'HR Generalist',
  'Training Manager',
  'Talent Acquisition Specialist',
  'Administrative Officer',
  'Office Administrator',
  'Receptionist',
  'Executive Assistant',
  'Personal Assistant',

  // Operations & Logistics
  'Operations Executive',
  'Supply Chain Manager',
  'Logistics Manager',
  'Warehouse Manager',
  'Procurement Manager',
  'Inventory Manager',
  'Production Manager',
  'Quality Manager',

  // Healthcare
  'Doctor',
  'Surgeon',
  'Medical Officer',
  'Nurse',
  'Staff Nurse',
  'Pharmacist',
  'Lab Technician',
  'Physiotherapist',
  'Healthcare Administrator',

  // Education
  'Teacher',
  'Lecturer',
  'Professor',
  'Assistant Professor',
  'Associate Professor',
  'Principal',
  'Vice Principal',
  'Academic Coordinator',
  'Research Scholar',
  'Research Associate',

  // Legal
  'Lawyer',
  'Advocate',
  'Legal Advisor',
  'Legal Counsel',
  'Paralegal',
  'Legal Associate',

  // Customer Service
  'Customer Service Executive',
  'Customer Support Executive',
  'Call Center Executive',
  'Technical Support Engineer',
  'Help Desk Technician',

  // Engineering
  'Mechanical Engineer',
  'Electrical Engineer',
  'Civil Engineer',
  'Design Engineer',
  'Quality Engineer',
  'Production Engineer',
  'Maintenance Engineer',
  'Site Engineer',
  'Project Engineer',

  // Others
  'Consultant',
  'Analyst',
  'Specialist',
  'Coordinator',
  'Officer',
  'Supervisor',
  'Team Member',
  'Associate',
  'Trainee',
  'Intern',
  'Other',
];

// Department options
export const departments = [
  'Information Technology',
  'Software Development',
  'Engineering',
  'Research & Development',
  'Operations',
  'Sales',
  'Marketing',
  'Business Development',
  'Human Resources',
  'Finance',
  'Accounting',
  'Administration',
  'Customer Service',
  'Customer Support',
  'Quality Assurance',
  'Production',
  'Manufacturing',
  'Supply Chain',
  'Logistics',
  'Procurement',
  'Legal',
  'Compliance',
  'Design',
  'Content',
  'Digital Marketing',
  'Public Relations',
  'Training & Development',
  'Healthcare',
  'Education',
  'Consulting',
  'Strategy',
  'Analytics',
  'Product Management',
  'Project Management',
  'Other',
];

// Sector/Industry options
export const sectors = [
  // Technology
  'Information Technology (IT)',
  'Software Development',
  'Computer Hardware',
  'Internet & E-commerce',
  'Telecommunications',
  'Electronics',
  'Artificial Intelligence & Machine Learning',
  'Data Science & Analytics',
  'Cybersecurity',
  'Cloud Computing',
  'Gaming',
  
  // Finance & Banking
  'Banking',
  'Financial Services',
  'Insurance',
  'Investment Banking',
  'Accounting',
  'Venture Capital & Private Equity',
  'FinTech',
  
  // Healthcare & Pharmaceuticals
  'Healthcare',
  'Hospitals & Clinics',
  'Pharmaceuticals',
  'Biotechnology',
  'Medical Devices',
  'Health Insurance',
  'Diagnostics',
  
  // Manufacturing & Industrial
  'Manufacturing',
  'Automotive',
  'Aerospace & Defense',
  'Heavy Engineering',
  'Industrial Equipment',
  'Chemicals',
  'Steel & Metal',
  'Textile & Apparel',
  
  // Retail & Consumer Goods
  'Retail',
  'E-commerce',
  'FMCG (Fast Moving Consumer Goods)',
  'Fashion & Lifestyle',
  'Food & Beverage',
  'Wholesale',
  
  // Real Estate & Construction
  'Real Estate',
  'Construction',
  'Architecture',
  'Interior Design',
  'Property Management',
  
  // Education
  'Education',
  'E-learning',
  'Training & Development',
  'Higher Education',
  'K-12 Education',
  
  // Consulting & Professional Services
  'Management Consulting',
  'IT Consulting',
  'HR Consulting',
  'Legal Services',
  'Accounting & Auditing',
  'Business Services',
  
  // Media & Entertainment
  'Media',
  'Entertainment',
  'Advertising',
  'Publishing',
  'Broadcasting',
  'Film & Television',
  'Music',
  'Animation & VFX',
  
  // Hospitality & Travel
  'Hospitality',
  'Hotels & Resorts',
  'Travel & Tourism',
  'Airlines',
  'Restaurants & Food Services',
  'Event Management',
  
  // Transportation & Logistics
  'Transportation',
  'Logistics',
  'Supply Chain',
  'Shipping',
  'Warehousing',
  'Courier & Delivery',
  
  // Energy & Utilities
  'Energy',
  'Oil & Gas',
  'Renewable Energy',
  'Utilities',
  'Power Generation',
  'Mining',
  
  // Agriculture
  'Agriculture',
  'Agribusiness',
  'Food Processing',
  'Dairy',
  'Horticulture',
  
  // Government & Public Sector
  'Government',
  'Public Administration',
  'Defense',
  'Law Enforcement',
  'Non-Profit Organization',
  'NGO',
  
  // Others
  'Research',
  'Sports & Fitness',
  'Beauty & Wellness',
  'Environmental Services',
  'Security Services',
  'Facilities Management',
  'BPO/KPO',
  'Market Research',
  'Other',
];

// Company name suggestions (commonly known companies - users can also type their own)
export const companyNames = [
  // IT & Tech Giants
  'Tata Consultancy Services (TCS)',
  'Infosys',
  'Wipro',
  'HCL Technologies',
  'Tech Mahindra',
  'Cognizant',
  'Accenture',
  'IBM',
  'Microsoft',
  'Google',
  'Amazon',
  'Apple',
  'Oracle',
  'SAP',
  'Capgemini',
  'DXC Technology',
  'LTI (Larsen & Toubro Infotech)',
  'Mindtree',
  'Mphasis',
  'Persistent Systems',
  'Zensar Technologies',
  
  // Indian IT Companies
  'Zoho Corporation',
  'Freshworks',
  'Flipkart',
  'Paytm',
  'Ola',
  'Zomato',
  'Swiggy',
  'PhonePe',
  'BYJU\'S',
  'Udaan',
  'ShareChat',
  'Dream11',
  
  // Banks & Financial Services
  'State Bank of India (SBI)',
  'HDFC Bank',
  'ICICI Bank',
  'Axis Bank',
  'Kotak Mahindra Bank',
  'Punjab National Bank',
  'Bank of Baroda',
  'Canara Bank',
  'IDBI Bank',
  'Yes Bank',
  'IndusInd Bank',
  'HSBC',
  'Citibank',
  'Standard Chartered',
  
  // Consulting
  'Deloitte',
  'PwC (PricewaterhouseCoopers)',
  'EY (Ernst & Young)',
  'KPMG',
  'McKinsey & Company',
  'Boston Consulting Group (BCG)',
  'Bain & Company',
  
  // Manufacturing & Industrial
  'Tata Motors',
  'Mahindra & Mahindra',
  'Maruti Suzuki',
  'Hyundai',
  'Larsen & Toubro (L&T)',
  'Reliance Industries',
  'Aditya Birla Group',
  'ITC Limited',
  'Godrej',
  'Bajaj',
  
  // Pharma & Healthcare
  'Sun Pharmaceutical',
  'Dr. Reddy\'s Laboratories',
  'Cipla',
  'Lupin',
  'Cadila Healthcare',
  'Apollo Hospitals',
  'Fortis Healthcare',
  'Max Healthcare',
  
  // FMCG & Retail
  'Hindustan Unilever',
  'Procter & Gamble',
  'Nestlé',
  'Britannia Industries',
  'Dabur',
  'Marico',
  'Colgate-Palmolive',
  'Big Bazaar',
  'Reliance Retail',
  'Spencer\'s',
  
  // Telecom
  'Reliance Jio',
  'Bharti Airtel',
  'Vodafone Idea',
  'BSNL',
  
  // Others
  'Self-Employed',
  'Freelance',
  'Startup',
  'Small Business',
  'Other',
];

/**
 * Fetch company names from various sources
 * This function attempts to fetch company suggestions from free APIs
 * Falls back to static list if API is unavailable
 * @param {string} query - Search query for company name
 * @returns {Promise<Array>} - Array of company name suggestions
 */
export const fetchCompanyNames = async (query = '') => {
  // Return static list if no query
  if (!query || query.trim().length < 2) {
    return companyNames;
  }

  try {
    // Filter static list based on query
    const filteredStatic = companyNames.filter(company =>
      company.toLowerCase().includes(query.toLowerCase())
    );

    // You can add additional API calls here when available
    // Example: Clearbit API (requires API key), LinkedIn, or other company databases
    
    // For now, return filtered static list
    return filteredStatic.length > 0 ? filteredStatic : companyNames;
  } catch (error) {
    console.error('Error fetching company names:', error);
    // Fallback to static list
    return companyNames;
  }
};

/**
 * Search companies from autocomplete.clearbit.com (Free API - No auth required)
 * Note: This API may have CORS restrictions and rate limits
 * @param {string} query - Company name to search
 * @returns {Promise<Array>} - Array of company suggestions
 */
export const searchCompaniesFromClearbit = async (query) => {
  if (!query || query.trim().length < 2) {
    return [];
  }

  try {
    const response = await fetch(`https://autocomplete.clearbit.com/v1/companies/suggest?query=${encodeURIComponent(query)}`);
    
    if (!response.ok) {
      throw new Error('Clearbit API request failed');
    }

    const data = await response.json();
    
    // Clearbit returns array of objects with { name, domain, logo }
    return data.map(company => company.name);
  } catch (error) {
    console.error('Clearbit API error:', error);
    return [];
  }
};
